/* SOYMOD #101297 (27/4/26) - */
document.addEventListener('DOMContentLoaded', () => {
  // 1. Comprobar que estamos en la página correcta (body con la clase específica)
  if (document.body.classList.contains('content-page-reserva-consulta')) {
    
    // 2. Buscar el enlace (botón) dentro de #MainContent
    const botonScroll = document.querySelector('#MainContent a[href="#ContactForm"], #MainContent a[href="#apntly-embed-widget-container-id"]'); /* SOYMOD #103773 (22/06/2026) – Añadido selector "#MainContent a[href="#apntly-embed-widget-container-id"]" */

    if (botonScroll) {
      botonScroll.addEventListener('click', (e) => {
        e.preventDefault();

        /* SOYMOD #103773 (22/06/2026) - Selecciona el formulario destino (ContactForm o widget Apntly) según el enlace pulsado, para que el scroll funcione con ambos formularios */
        // // 3. Buscar el elemento cuyo ID empiece por ContactForm
        // const formBase = document.querySelector('[id^="ContactForm"]');
        //
        // if (formBase) {
        //   // 4. Obtener el abuelo del formulario (parent parent)
        //   const targetElement = formBase.parentElement.parentElement;
        //
        //   // 5. Calcular la altura del header
        //   const header = document.querySelector('header.header-section');
        //   const headerHeight = header ? header.offsetHeight : 0;
        //
        //   // 6. Calcular la posición y realizar el scroll suave
        //   const elementPosition = targetElement.getBoundingClientRect().top;
        //   const offsetPosition = elementPosition + window.scrollY - headerHeight;
        //
        //   window.scrollTo({
        //     top: offsetPosition,
        //     behavior: 'smooth'
        //   });
        // }
        // 3. Determinar el formulario destino según el enlace pulsado
        const href = botonScroll.getAttribute('href');
        let targetElement = null;

        if (href === '#apntly-embed-widget-container-id') {
          // Formulario del widget Apntly: el propio contenedor es el destino
          formBase = document.querySelector('#apntly-embed-widget-container-id');
          if (formBase) {
            targetElement = formBase.parentElement.parentElement;
          }
        } else {
          // Formulario de contacto: usar el abuelo del elemento ContactForm
          const formBase = document.querySelector('[id^="ContactForm"]');
          if (formBase) {
            targetElement = formBase.parentElement.parentElement;
          }
        }

        if (targetElement) {
          // 5. Calcular la altura del header
          const header = document.querySelector('header.header-section');
          const headerHeight = header ? header.offsetHeight : 0;

          // 6. Calcular la posición y realizar el scroll suave
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
        /* End MOD */
      });
    }
  }
});
/* End MOD */

/* SOYMOD #103478 (25/05/2026) - Descripción desplegable en móvil */
document.addEventListener('click', function (event) {
  var button = event.target.closest('.soy_collapse_toggle');
  if (!button) return;

  var expanded = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', String(!expanded));

  var container = button.previousElementSibling;
  if (container && container.classList.contains('soy_collapsed')) {
    container.classList.toggle('soy_collapsed--open');
  }
});

/* End MOD */

/* SOYMOD #103773 (22/06/2026) - Nuevo bloque: detecta el iframe del widget Apntly (puede inyectarse por JS, por eso MutationObserver) e inyecta CSS dentro para mostrar sólo España, Reino Unido, Portugal y Francia en el selector de prefijo telefónico */
(function () {
  const IFRAME_SELECTOR = '#apntly-booking-iframe';
  const STYLE_ID = 'soymod-103773-filtro-paises';

  // CSS a inyectar DENTRO del iframe. Es un iframe srcdoc → mismo origin que la
  // página, así que podemos acceder a su documento. Oculta todos los items del
  // desplegable de países salvo los permitidos, identificados por la clase de su
  // bandera: España (es), Reino Unido (gb), Portugal (pt) y Francia (fr).
  // Se usa :not(:has(...)), soportado en navegadores modernos.
  const CSS = `
    .vti__dropdown-list .vti__dropdown-item:not(:has(.vti__flag.es, .vti__flag.gb, .vti__flag.pt, .vti__flag.fr)) {
      display: none !important;
    }

    /* SOYMOD #103773 (23/06/2026) – Ocultar selector de variantes */
    #variant-container {
      display: none;
    }
    /* End MOD */
  `;

  // Inyecta el <style> en el <head> del documento del iframe. Devuelve true si
  // se inyectó (o ya estaba), false si el documento aún no es accesible/listo.
  function inyectarCss(iframe) {
    let doc;
    try {
      doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
    } catch (e) {
      return false; // cross-origin: sin acceso al documento interno
    }
    if (!doc || !doc.head) return false;
    if (doc.getElementById(STYLE_ID)) return true; // ya inyectado en ESTE documento

    const style = doc.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    doc.head.appendChild(style);
    return true;
  }

  // El iframe arranca con un documento about:blank que luego es reemplazado por
  // el de srcdoc; inyectar en el blank no sirve (se descarta al cargar el real).
  function docRealCargado(iframe) {
    try {
      const win = iframe.contentWindow;
      const href = win && win.location ? win.location.href : '';
      return !!href && href !== 'about:blank';
    } catch (e) {
      return false;
    }
  }

  // Procesa el iframe: deja un listener que reinyecta en CADA (re)carga del
  // documento, e inyecta ya si el documento real está cargado.
  function procesarIframe(iframe) {
    if (iframe.dataset.soymodObservado === 'ok') return; // listener ya registrado
    iframe.dataset.soymodObservado = 'ok';

    // Reinyecta en cada load: el documento inicial about:blank se reemplaza por
    // el de srcdoc y eso borra cualquier <style> que hubiéramos inyectado antes.
    iframe.addEventListener('load', function () {
      inyectarCss(iframe);
    });

    // Si el documento real ya está cargado (el load pudo dispararse antes de
    // registrar el listener), inyectamos ahora; si sigue en about:blank, esperamos.
    if (docRealCargado(iframe)) {
      inyectarCss(iframe);
    }
  }

  // Busca el iframe en el DOM; si está, lo procesa. Devuelve el elemento (o null).
  function buscarIframe() {
    const iframe = document.querySelector(IFRAME_SELECTOR);
    if (iframe) procesarIframe(iframe);
    return iframe;
  }

  // 1. ¿Ya existe el iframe al ejecutarse el script?
  buscarIframe();

  // 2. Observamos el DOM por si el iframe se inyecta (o se recrea) por JS. No
  //    desconectamos: si el widget destruye y recrea el iframe, lo recogeremos
  //    de nuevo (el guard dataset.soymodObservado evita listeners duplicados).
  const observer = new MutationObserver(function () {
    buscarIframe();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
/* End MOD */